import {createAction} from 'redux-actions'

export const update = createAction('REMOTE_INSPECTIONS/VALUES/UPDATE')
export const setLoading = createAction('REMOTE_INSPECTIONS/VALUES/SET_LOADING', (isLoading = true) => ({isLoading}))
export const clear = createAction('REMOTE_INSPECTIONS/VALUES/CLEAR')
export const fetch = createAction('REMOTE_INSPECTIONS/VALUES/FETCH')
